import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { Button } from '@smartplatform/ui';
import XLSX from 'xlsx';
import moment from 'moment';
import store from '../../store';
import { sortedUniqBy } from 'lodash';

@observer
export default class ExportDiscussions extends React.Component {
	@observable discussions;
	@observable loading = false;

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		const discussions = await store.model.Discussion.find({
			order: 'id desc',
			include: [
				{
					relation: 'poll',
					scope: {
						include: {
							relation: 'fields',
							scope: {
								include: 'votes',
							},
						},
					},
				},
				{
					relation: 'comments',
					scope: {
						where: {
							publish: true,
						},
					},
				},
			],
		});
		this.discussions = discussions;
	};

	exportData = async () => {
		this.loading = true;
		const wb = XLSX.utils.book_new();

		const excelData = this.discussions.map((discusssion, index) => {
			const { name, startDate, endDate, poll } = discusssion;

			let total = 0;
			let pollResults = 'Нет обсуждения';
			const fields = poll && poll.fields();
			if (fields) {
				fields.forEach(field => (total += field.votes().length));
				pollResults = fields.map(field => {
					const name = field.user ? 'Свой вариант' : field.name;
					const value = field.votes().length;
					const persent = ((value * 100) / total).toFixed(1);
					return value !== 0 && `${name} - ${value} (${persent} %)`;
				});

				pollResults = pollResults.filter(r => r).join('\n');
				pollResults += '\n Всего:  ' + total;
			}

			const comments = discusssion.comments();
			const participants = sortedUniqBy(comments, e => e.name);

			return {
				'№': index,
				'Наименование общественного обсуждения': name,
				'Дата начала': moment(startDate).format('LLL'),
				'Дата окончания': moment(endDate).format('LLL'),
				'Количество участников': participants.length,
				'Количество комментариев': comments.length,
				'Итоги голосования': pollResults,
			};
		});

		const ws = XLSX.utils.json_to_sheet([...excelData]);

		ws['!cols'] = [{ wch: 15 }, { wch: 60 }, { wch: 30 }, { wch: 30 }, { wch: 20 }, { wch: 20 }, { wch: 60 }];
		ws['!rows'] = new Array(this.discussions.length + 1).fill({ hpx: 30 });
		XLSX.utils.book_append_sheet(wb, ws, 'Обсуждения');
		this.loading = false;
		XLSX.writeFile(wb, 'Общественные обсуждения.xlsx');
	};

	render() {
		if (!this.discussions) {
			return <div>...</div>;
		}
		return (
			<>
				{!this.loading ? (
					<Button label="Экспортировать данные в Excel" onClick={this.exportData} />
				) : (
					<p> Готовлю данные к эксорту</p>
				)}
			</>
		);
	}
}
